import PaymentPageB2CSection from "../../components/NewDesign/Payment/PaymentPageB2CSection/PaymentPageB2CSection";
import PaymentOutlinePage from "../../components/PaymentOutlinePage";
import { useState, useEffect } from "react";
import CONFIG from "../../utils/config";
import $ from "jquery";
import Loader from "../../components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys, clickStreamUser } from "../../utils/AppUtils";
import { setIframeUserRole, userDetailBroker } from "../../redux/user/actions";
import { loginIframeUserResponse } from "../../redux/auth/actions";
import _ from "lodash";
import {
  cartPageDataResponse,
  subscriptionCheckoutPage,
  subscriptionCheckoutPageClear,
} from "../../redux/checkout/actions";

const PaymentB2CPageMobile = (props) => {
  const dispatch = useDispatch();
  console.log("type--", props.type);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const email = params.get("email");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");
  const product_id = params.get("product_id");
  const subscription_id = params.get("subscription_id");
  const billing_type = params.get("billing_type");

  const [isLoading, setIsLoading] = useState(true);
  const [isValidKey, setIsValidKey] = useState(false);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  const cartPageData = useSelector((state) => state.checkout.cartPageData);
  const subscriptionCheckoutPageResp = useSelector(
    (state) => state.checkout.subscriptionCheckoutPage
  );

  useEffect(() => {
    if (!_.isEmpty(subscriptionCheckoutPageResp)) {
      setIsLoading(false);
    }
  }, [subscriptionCheckoutPageResp]);

  useEffect(() => {
    if (!_.isEmpty(cartPageData) && !props.type === "subscription") {
      setIsLoading(false);
    }
  }, [cartPageData]);

  useEffect(() => {
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2
      );
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.USERNAME, username);
      setIsValidKey(true);
      if (role === "pmpro_membership_manager") {
        dispatch(setIframeUserRole("broker"));
      } else if (role === "broker_admin") {
        dispatch(setIframeUserRole("admin"));
      }

      dispatch(
        loginIframeUserResponse({
          payload: {
            user: {
              user_id: user_id,
              username: email,
              email: email,
              role: [role],
            },
            apiToken: token,
          },
        })
      );
      if(token) {
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN),
          user_id: user_id,
        })
      );
    }
      if (props.type === "subscription") {
        dispatch(
          subscriptionCheckoutPage({
            subscriptionId: subscription_id,
            billingType: billing_type,
          })
        );
      } else {
        dispatch(cartPageDataResponse({ load: false, productId: product_id }));
      }
      setIsLoading(false);

      clickStreamUser("payment_add_mobile_page", {
        userId: user_id,
      });
    }
  }, [token, key, user_id, dispatch]);

  //   const userDetailRes = useSelector((state) => state.user.userBroker);

  //   useEffect(() => {
  //     if (!_.isEmpty(userDetailRes)) {
  //       if (userDetailRes.status === "success") {
  //         setloggedIn(true);
  //         setIsLoading(false);
  //       }
  //     }
  //   }, [userDetailRes]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Loader start={isLoading} />
      {isValidKey ? (
        <>
          <PaymentOutlinePage isMobile={true}>
            <PaymentPageB2CSection {...props} isMobile={true} />
          </PaymentOutlinePage>
        </>
      ) : (
        <div>Invalid Key</div>
      )}
    </>
  );
};

export default PaymentB2CPageMobile;
